export var appConfig = {
  //insaServiceAddress: "http://localhost:9000/api",
  //authServiceAddress: "http://localhost:9000",
  //insaServiceAddress: "http://localhost:9000/api",
  //authServiceAddress: "http://localhost:9000",
  //pivotViewerServiceAddress: "http://localhost:9000",
  //insaServiceAddress: "http://localhost:3000/InsaWebApi/api",
  //authServiceAddress: "http://localhost:3000",
  //pivotViewerServiceAddress: "http://localhost:3000",
  // insaServiceAddress: "https://www.insa-support.com/InsaWebApi/api",
  // authServiceAddress: "https://www.insa-support.com/InsaWebApi",
  // pivotViewerServiceAddress: "/InsaPivot",
  pivotViewerServiceAddress: "http://localhost:51438",
  insaServiceAddress: "http://localhost:51438/api",
  authServiceAddress: "http://localhost:51438",
  //insaServiceAddress: "http://localhost/InsaWebApi/api",
  //authServiceAddress: "http://localhost/InsaWebApi",

  certBridgeBaseUrl: "https://192.168.178.39:5001/CertAuthApp",

  //pivotViewerServiceAddress: "http://www.insa-support.com/InsaWebApi",
  showPasswordChangeButtonOnLogin: false,
  showNewsMockup: false,
  showForgotPasswordButtonOnLogin: false,
  showLanguageChangeButtonOnLogin: true,
  //loginText: "If you experience any problems logging in, please notify us at <a href=\"mailto:support@insa-software.com\"> support@insa-software.com</a>.",
  loginText:
    'To obtain login credentials, please contact us at <a href="mailto:support@insa-software.com"> support@insa-software.com</a>.',
  ClientTitle: "Online Portal",
  performanceChartSecondSerieName: "",
  portfolioGridSmallScreenColumns: [
    "SecName",
    "Quantity",
    "Currency",
    "CurrentPrice",
    "Valuation",
    "ProfitPerc",
  ],
  transactionsGridSmallScreenColumns: [
    "SecName",
    "QuantityWithoutCash",
    "TransAmountRC",
    "TransDate",
    "Description",
  ],
  clientSpecificColumnHidden: ["SecNumber"],
  hidePerformanceChartListColumn: true,
  hideSecurityPricesVolume: false,
  sortTransactionsByDefault: false,
  multiSelectWidthSettings: false,
  dropdownWidthSettings: false,
  hideIncludeIgnoredTransactions: true,
  printButtonVisible: false,
  setCarouselTimeout: 10000,
  idleTimeoutMinutes: 15,
  version: 3.2,
  showThemeSelection: true,
  menuShowRiskProfile: true,
  menuShowMainWindow: true,
  menuShowClientContacts: true,
  menuShowGenericForms: true,
  menuShowDashboard: false,
  menuShowSecurity: false,
  menuShowCrossRates: true,
  menuShowOrdersWindow: true,
  appUserWelcome: true,
  translationsVersion: 3.1,
  availableLocales: [
    "en-US",
    "de-DE",
    "es-ES",
    "it-IT",
    "hr-HR",
    "fr-FR",
    "sr-RS",
  ],
  allowTracking: true,
  SecMainClass_LIQUIDITY: 0,
  chartColors: [
    "#00dcfa",
    "#00b4c8",
    "#008ca0",
    "#005f69",
    "#004147",
    "#6C7071",
    "#555859",
    "#3A3D3D",
    "#202121",
  ],
  ActiveIsChecked: true,
  InsaCronAvailable: true,
  portalLoginStatsAvaliable: true,
  NavigateToReferrerOnLogout: true,
  menuShowNews: false,
  enableLockedCOlumnONPortfolioGrid: false,
  menuShowInsaTrader: true,
  defaultLocale: "en-US",
  IsTraderApp: false,
  useLegacyIcons: true,
  showMobileTraderShortcut: true,
   isHoli: true,
  consolidateAllPositionsVisible: true,
  separatePositionsByPortfolioVisible: true,
  passwordChangeInSettingsVisible: false,
  chartThemes: {
    default: {
      layout: {
        backgroundColor: "#ffffff",
        textColor: "#131722",
      },
      grid: {
        vertLines: { color: "rgba(42, 46, 57, 0.1)" },
        horzLines: { color: "rgba(42, 46, 57, 0.1)" },
      },
      crosshair: {
        vertLine: { color: "rgba(42, 46, 57, 0.4)" },
        horzLine: { color: "rgba(42, 46, 57, 0.4)" },
      },
      border: "rgba(42, 46, 57, 0.3)",
    },
    black: {
      layout: {
        backgroundColor: "#0f0f0f",
        textColor: "#ffffff",
      },
      grid: {
        vertLines: { color: "#2c2c2c" },
        horzLines: { color: "#2c2c2c" },
      },
      crosshair: {
        vertLine: { color: "rgba(255, 255, 255, 0.3)" },
        horzLine: { color: "rgba(255, 255, 255, 0.3)" },
      },
      border: "#2c2c2c",
    },
  },
  initialSettings: {
    enabled: false,
    redirectAfterLogin: "overview",
    dateFrom: "startOfYear",
    dateTo: "today",
    currency: "CHF",
    availableCurrencies: "all",
    partner: "all",
    portfolios: "all",
  },
  customIconGraph: {
    enabled: false,
    fallBackSecurity: "AMZN",
    pageRedirect: "/trader",
  },
  overviewCardColumns: {
    default: "col-md-6 col-sm-6 col-lg-4",
  },
  customReport: false,
  	OverviewCards: [
		"Portfolio",
		"Charts",
		"Performance",
		"Transactions",
		"CrossRates",
		"News",
	],
};



// WEBPACK FOOTER //
// ./insaweb.default.DEVELOPMENT.config.ts